import { StyledRoot } from "./styled";
import { IRootProps } from "./types";
import { useDrawerStore } from "src/store/drawerStore";

const Root = ({ children, ...props }: IRootProps) => {
    const open = useDrawerStore((s: any) => s.open);
    const isFullscreen = useDrawerStore((s: any) => s.isFullscreen);

    return (
        <StyledRoot
            variant="persistent"
            anchor="right"
            open={open}
            isFullscreen={isFullscreen}
            {...props}
        >
            {children}
        </StyledRoot>
    )

}

export {Root}